// extracted by mini-css-extract-plugin
export const projectsHomepage = "projects-module--projectsHomepage--1LCPk";
export const projectsList = "projects-module--projectsList--72zWv";
export const tilt = "projects-module--tilt---NfwH";
export const project = "projects-module--project--1zdcJ";
export const content = "projects-module--content--3gdUy";
export const img = "projects-module--img--3c9-u";
export const readMore = "projects-module--readMore--312Yr";